/* eslint-disable perfectionist/sort-maps */
import { PatientProtocolFrequency } from '@shared/services/gql.service';

export const MAP_FREQUENCY_TITLE_BY_TYPE = new Map<PatientProtocolFrequency, string>([
  [PatientProtocolFrequency.PATIENT_PROTOCOL_FREQUENCY_ACTIVATION, 'Activation'],
  [PatientProtocolFrequency.PATIENT_PROTOCOL_FREQUENCY_MONTHLY, 'Monthly'],
  [PatientProtocolFrequency.PATIENT_PROTOCOL_FREQUENCY_QUARTERLY, 'Quarterly'],
  [PatientProtocolFrequency.PATIENT_PROTOCOL_FREQUENCY_ANNUALLY, 'Annually'],
  [PatientProtocolFrequency.PATIENT_PROTOCOL_FREQUENCY_CLOSEOUT, 'Closeout'],
]);

export const FREQUENCY_OPTIONS = Object.keys(PatientProtocolFrequency);
